import MUserInfoCard from './MUserInfoCard.vue';

export { MUserInfoCard };
export default MUserInfoCard;
